import { connect } from 'react-redux';
import Content from './Content';

const mapStateToProps = ({
  content: { sections },
  renderOptions: { showPropertyTypes, showTrustPilot, showTrustPilotEU }
}) => ({
  sections,
  showPropertyTypes,
  showTrustPilot,
  showTrustPilotEU
});

export default connect(mapStateToProps)(Content);
